import { render, staticRenderFns } from "./Careerpage.vue?vue&type=template&id=08946e8a&"
import script from "./Careerpage.vue?vue&type=script&lang=js&"
export * from "./Careerpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports